var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#2E95DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0005 29.999C23.2848 29.999 30.0005 23.2833 30.0005 14.999C30.0005 12.4173 29.3482 9.98786 28.1995 7.86658C25.5624 5.56217 22.1112 4.16602 18.334 4.16602C10.0497 4.16602 3.33398 10.8817 3.33398 19.166C3.33398 21.7478 3.98624 24.1772 5.13494 26.2985C7.7721 28.6029 11.2233 29.999 15.0005 29.999Z",
    fill: "#45A2E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 13.6091C16.5127 13.6091 17.739 12.3828 17.739 10.87C17.739 9.35721 16.5127 8.13086 14.9999 8.13086C13.4871 8.13086 12.2607 9.35721 12.2607 10.87C12.2607 12.3828 13.4871 13.6091 14.9999 13.6091Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.478 15.1747C21.5585 15.1747 22.4345 14.2988 22.4345 13.2182C22.4345 12.1377 21.5585 11.2617 20.478 11.2617C19.3974 11.2617 18.5215 12.1377 18.5215 13.2182C18.5215 14.2988 19.3974 15.1747 20.478 15.1747Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5776 15.1747C10.6582 15.1747 11.5341 14.2988 11.5341 13.2182C11.5341 12.1377 10.6582 11.2617 9.5776 11.2617C8.49705 11.2617 7.62109 12.1377 7.62109 13.2182C7.62109 14.2988 8.49705 15.1747 9.5776 15.1747Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 14.3918C12.1952 14.3918 9.91309 16.6739 9.91309 19.4788C9.91309 19.6948 10.0884 19.8701 10.3044 19.8701H19.6957C19.9117 19.8701 20.087 19.6948 20.087 19.4788C20.087 16.6739 17.8049 14.3918 15.0001 14.3918Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2519 16.0416C10.0124 15.9907 9.76903 15.957 9.52174 15.957C7.58009 15.957 6 17.5371 6 19.4788C6 19.6948 6.17532 19.8701 6.39132 19.8701H9.20243C9.15859 19.7472 9.13042 19.6165 9.13042 19.4788C9.13042 18.1945 9.54991 17.0089 10.2519 16.0416Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4782 15.957C20.2309 15.957 19.9875 15.9907 19.748 16.0416C20.45 17.0089 20.8695 18.1945 20.8695 19.4788C20.8695 19.6165 20.8414 19.7472 20.7975 19.8701H23.6086C23.8246 19.8701 24 19.6948 24 19.4788C24 17.5371 22.4199 15.957 20.4782 15.957Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlly);
export default __webpack_public_path__ + "static/media/ally.56ae8705e187744170e7a3f5814dc166.svg";
export { ForwardRef as ReactComponent };